export default month => {
  if (month === 'Janeiro') { return 0 }
  else if (month === 'Fevereiro') { return 1 }
  else if (month === 'Março') { return 2 }
  else if (month === 'Abril') { return 3 }
  else if (month === 'Maio') { return 4 }
  else if (month === 'Junho') { return 5 }
  else if (month === 'Julho') { return 6 }
  else if (month === 'Agosto') { return 7 }
  else if (month === 'Setembro') { return 8 }
  else if (month === 'Outubro') { return 9 }
  else if (month === 'Novembro') { return 10 }
  else if (month === 'Dezembro') { return 11 }
  else { return false }
}
